
import { Party } from "@/utils/peppol/party";
import Vue from "vue";

export default Vue.extend({
	props: {
		party: {
			type: Object as ()=>Party,
			required: true
		}
	}
});
